import { render, staticRenderFns } from "./FinanceSection.vue?vue&type=template&id=45b9f302"
import script from "./FinanceSection.vue?vue&type=script&lang=js"
export * from "./FinanceSection.vue?vue&type=script&lang=js"
import style0 from "./FinanceSection.vue?vue&type=style&index=0&id=45b9f302&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports